import { ButtonBlock, ButtonBlockProps } from '@jbhi-fi/components/src/ButtonBlock/ButtonBlock';
import React from 'react';
import { useCustomerApi } from '../../../customers/hooks/customerApi';
import { LanyardButtonProps } from '@jbhi-fi/components/src/Contentful/transformers/ButtonTransformer';

const PERKS_JOIN_BUTTON = 'Join JB Perks';
const PERKS_LOG_IN_BUTTON = 'Log into JB Perks';

export const PerksButtonBlock = ({ buttons, alignment, divider }: ButtonBlockProps) => {
  const { customer } = useCustomerApi();
  const isPerks = window.Jbhifi.customerDetails?.isPerks;

  const displayAvailableButtons = (): Array<LanyardButtonProps> => {
    if (!customer?.id) return buttons;

    if (!isPerks) {
      return buttons
        .filter(({ name }) => name !== PERKS_LOG_IN_BUTTON)
        .map(btn => (btn.name === PERKS_JOIN_BUTTON ? { ...btn, type: 'primary' } : btn));
    }

    return buttons.filter(({ name }) => name !== PERKS_JOIN_BUTTON && name !== PERKS_LOG_IN_BUTTON);
  };

  return <ButtonBlock buttons={displayAvailableButtons()} alignment={alignment} divider={divider} />;
};
